






































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins, Watch } from 'vue-property-decorator';

@Component
export default class PropertyGroupsModal extends Mixins(ModalMixin) {
  form!: CrsForm<'propertyGroups', 'create' | 'update'>;

  propertyOptions = [];

  @Watch('mode', { immediate: true })
  switchForm(mode: 'create' | 'update') {
    this.form = this.$crsForm('propertyGroups', mode, {
      isActive: false,
      name: '',
      properties: [],
    });
  }

  async getForm() {
    return compass.do('propertyGroups', 'findOne', { params: { id: this.id } });
  }

  mounted() {
    this.$getCrsList('properties', 'find', {
      select: ['name'],
    }).then((res: any) => {
      this.propertyOptions = res.map((prop: any) => {
        return {
          label: prop.name,
          value: prop.id,
        };
      });
    });
  }
}
